import { Component, OnDestroy, OnInit } from '@angular/core';
import { CheckSheetAssignmentProjection, User } from '@completion/models';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import {
  getSelectedProcurementPackages,
  getSelectedSupplierCheckSheetAssignments,
  getSelectedVendorUsersForScope,
} from '@completion/selectors';
import { takeUntil } from 'rxjs/operators';
import { RemoveSelectedVendorUser } from '@completion/actions';
import { ProcurementPackage } from '../../shared/models/procurement-package';

@Component({
  selector: 'app-verify-selection',
  templateUrl: './verify-selection.component.html',
  styleUrls: ['./verify-selection.component.scss'],
  standalone: false,
})
export class VerifySelectionComponent implements OnInit, OnDestroy {
  selectedProcurementPackages: ProcurementPackage[] = [];
  selectedAssignments: CheckSheetAssignmentProjection[] = [];
  selectedVendorUsers: User[] = [];

  displayedColumns: string[] = [
    '#',
    'procurementPackageNumber',
    'commissioningPackageNumber',
    'mcPackageNumber',
    'tagNumber',
    'companyNumber',
    'status',
  ];
  private destroy$ = new Subject<void>();
  constructor(
    private store: Store,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.store
      .select(getSelectedVendorUsersForScope)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) {
          this.selectedVendorUsers = [...data]; // Ensure the array is not frozen
        }
      });
    this.store
      .select(getSelectedProcurementPackages)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) {
          this.selectedProcurementPackages = [...data]; // Ensure the array is not frozen
        }
      });

    this.store
      .select(getSelectedSupplierCheckSheetAssignments)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) {
          this.selectedAssignments = [...data]; // Ensure the array is not frozen
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  removeSupplier(supplier: User) {
    this.store.dispatch(new RemoveSelectedVendorUser(supplier));
  }
}
